import { Language } from 'prism-react-renderer';

import Stats from './Stats';
import Code from './Code';
import InlineCode from './InlineCode';

require(`prismjs/components/prism-swift`);

type CodeBlockProps = {
  children: string;
  className: string | null;
  noCopy?: boolean;
};

export default function CodeBlock({
  children,
  className = null,
  ...props
}: CodeBlockProps) {
  if (!children) return null;
  if (!className) return <InlineCode {...{ children }} />;

  const language = className.replace(/lang(uage)?-/, ``);

  switch (language) {
    case `stats`: {
      const code = JSON.parse(children);

      return <Stats>{code}</Stats>;
    }
    default:
      return (
        <Code
          {...{ children, className, language: language as Language, ...props }}
        />
      );
  }
}
